import { DeviceManifest } from '@rapoo/device-sdk'
import {
  esk900KeyboardConfig,
  itineraryEnabled,
  keyFeaturesFull,
  keyboardMacro,
} from './generate/capabilityPresets'
import { esk90083Keys } from './generate/keysGenerate'
import { esk900KeyboardLightingEffects } from './generate/lightingPresets'

/**
 * ESK900-83RT 设备清单
 **/
const rapooESK90083RT: DeviceManifest = {
  channel: ['china_cybercafe'],
  model: 'ESK900-83RT',
  mainControl: 'ESK900-83RT',
  type: 'keyboard',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: [0x481b],
    currentPid: 0x481b,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 2,
        description: 'Configuration Interface (Secondary)',
        type: 'default',
      },
      {
        usagePage: 65392,
        usage: 113,
        description: 'Only update Firmware',
        type: 'update',
      },
    ],
  },
  driver: 'CH585M',
  ui: {
    assetsDir: 'manifests/ESK900-83RT',
    // 颜色配置
    colors: {
      series: [
        {
          name: 'common.products.ESK900_83RT.Phantom_Green',
          value: '#376F37',
          key: 'Phantom_Green',
        },
        {
          name: 'common.products.ESK900_83RT.Translucent_Black',
          value: '#E54F4F',
          key: 'Translucent_Black',
        },
        {
          name: 'common.products.ESK900_83RT.Black_Mist',
          value: '#2B2B2B',
          key: 'Black_Mist',
        },
      ],
      current: 'Translucent_Black',
    },
    // 小图标
    icon: 'Hardware-Wireframe-Keyboard',
    // 是否支持设备概览
    overview: false,
  },
  capabilities: [
    esk900KeyboardConfig,
    {
      type: 'lighting',
      config: {
        enable: true,
        effects: esk900KeyboardLightingEffects,
      },
    },
    itineraryEnabled,
    keyFeaturesFull,
    {
      type: 'keys',
      config: esk90083Keys,
    },
    keyboardMacro,
  ],
  layout: {
    image: 'frame',
    top: 24,
    bottom: 24,
    left: 18,
    right: 18,
    unit: 40,
    keys: [
      [
        {
          key: 0,
          keywords: 'Esc',
        },
        {
          key: 1,
          keywords: 'F1',
        },
        {
          key: 2,
          keywords: 'F2',
        },
        {
          key: 3,
          keywords: 'F3',
        },
        {
          key: 4,
          keywords: 'F4',
        },
        {
          key: 5,
          keywords: 'F5',
        },
        {
          key: 6,
          keywords: 'F6',
        },
        {
          key: 7,
          keywords: 'F7',
        },
        {
          key: 8,
          keywords: 'F8',
        },
        {
          key: 9,
          keywords: 'F9',
        },
        {
          key: 10,
          keywords: 'F10',
        },
        {
          key: 11,
          keywords: 'F11',
        },
        {
          key: 12,
          keywords: 'F12',
        },
        {
          key: 13,
          keywords: 'PrintScreen',
        },
        {
          key: 14,
          keywords: 'Delete',
        },
        {
          key: 15,
          keywords: 'RT',
        },
      ],
      [
        {
          key: 22,
          keywords: '~_`',
        },
        {
          key: 23,
          keywords: '!_1',
        },
        {
          key: 24,
          keywords: '@_2',
        },
        {
          key: 25,
          keywords: '#_3',
        },
        {
          key: 26,
          keywords: '$_4',
        },
        {
          key: 27,
          keywords: '%_5',
        },
        {
          key: 28,
          keywords: '^_6',
        },
        {
          key: 29,
          keywords: '&_7',
        },
        {
          key: 30,
          keywords: '*_8',
        },
        {
          key: 31,
          keywords: '(_9',
        },
        {
          key: 32,
          keywords: ')_0',
        },
        {
          key: 33,
          keywords: '__-',
        },
        {
          key: 34,
          keywords: '+_=',
        },
        {
          key: 35,
          keywords: 'BackSpace',
          w: 2,
        },
        {
          key: 36,
          keywords: 'Home',
        },
      ],
      [
        {
          key: 44,
          keywords: 'Tab',
          w: 1.5,
        },
        {
          key: 45,
          keywords: 'Q',
        },
        {
          key: 46,
          keywords: 'W',
        },
        {
          key: 47,
          keywords: 'E',
        },
        {
          key: 48,
          keywords: 'R',
        },
        {
          key: 49,
          keywords: 'T',
        },
        {
          key: 50,
          keywords: 'Y',
        },
        {
          key: 51,
          keywords: 'U',
        },
        {
          key: 52,
          keywords: 'I',
        },
        {
          key: 53,
          keywords: 'O',
        },
        {
          key: 54,
          keywords: 'P',
        },
        {
          key: 55,
          keywords: '{_[',
        },
        {
          key: 56,
          keywords: '}_]',
        },
        {
          key: 57,
          keywords: '|_\\',
          w: 1.5,
        },
        {
          key: 58,
          keywords: 'End',
        },
      ],
      [
        {
          key: 66,
          keywords: 'CapsLock',
          w: 1.75,
        },
        {
          key: 67,
          keywords: 'A',
        },
        {
          key: 68,
          keywords: 'S',
        },
        {
          key: 69,
          keywords: 'D',
        },
        {
          key: 70,
          keywords: 'F',
        },
        {
          key: 71,
          keywords: 'G',
        },
        {
          key: 72,
          keywords: 'H',
        },
        {
          key: 73,
          keywords: 'J',
        },
        {
          key: 74,
          keywords: 'K',
        },
        {
          key: 75,
          keywords: 'L',
        },
        {
          key: 76,
          keywords: ':_;',
        },
        {
          key: 77,
          keywords: '"_\'',
        },
        {
          key: 78,
          keywords: 'Enter',
          w: 2.25,
        },
        {
          key: 79,
          keywords: 'PgUp',
        },
      ],
      [
        {
          key: 88,
          keywords: 'Shift_L',
          w: 2.25,
        },
        {
          key: 89,
          keywords: 'Z',
        },
        {
          key: 90,
          keywords: 'X',
        },
        {
          key: 91,
          keywords: 'C',
        },
        {
          key: 92,
          keywords: 'V',
        },
        {
          key: 93,
          keywords: 'B',
        },
        {
          key: 94,
          keywords: 'N',
        },
        {
          key: 95,
          keywords: 'M',
        },
        {
          key: 96,
          keywords: '<_,',
        },
        {
          key: 97,
          keywords: '>_.',
        },
        {
          key: 98,
          keywords: '?_/',
        },
        {
          key: 99,
          keywords: 'Shift_R',
          w: 1.75,
        },
        {
          key: 100,
          keywords: '↑',
        },
        {
          key: 101,
          keywords: 'PgDn',
        },
      ],
      [
        {
          key: 110,
          keywords: 'Ctrl_L',
          w: 1.25,
        },
        {
          key: 111,
          keywords: 'Win_L',
          w: 1.25,
        },
        {
          key: 112,
          keywords: 'Alt_L',
          w: 1.25,
        },
        {
          key: 113,
          keywords: 'Space_L',
          w: 6.25,
        },
        {
          key: 114,
          keywords: 'Fn',
          w: 1.25,
        },
        {
          key: 115,
          keywords: 'Ctrl_R',
          w: 1.25,
        },
        {
          key: 116,
          keywords: '←',
          x: 0.5,
        },
        {
          key: 117,
          keywords: '↓',
        },
        {
          key: 118,
          keywords: '→',
        },
      ],
    ],
  },
}

export default rapooESK90083RT
